import React, { useState, useEffect, Fragment } from 'react';
import PageHeader from 'components/common/PageHeader';
import { Col, Button } from 'react-bootstrap';
import '../../../../assets/scss/user.scss';
import dayjs from 'dayjs';
import 'react-datepicker/dist/react-datepicker.css';
import { search } from 'services/bs-sector-measurable/measurableService';
import { get as getKpi } from 'services/bs-kpi-board/kpiBoardService';
import { getSectors } from 'services/bs-sector-measurable/sectorService';
import SectorModal from './SectorModal';
import { Navigate, useParams } from 'react-router-dom';
import { buildSicBoardPath, SIC_BOARD_TYPE } from 'helpers/sicHelper';
import Error404 from 'components/errors/Error404';
import FullPageSpinner from 'components/common/full-page-spinner';
import SectorCard from './Sectors/SectorCard';

export default function BalancedScorecard() {
  const { id } = useParams();
  const [kpi, setKpi] = useState(undefined);
  const [sectors, setSectors] = useState([]);
  const [sectorItem, setSectorItem] = useState({});
  const [isSectorModalShow, setSectorModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    getKpi(id).then(x => {
      if (x.data) {
        setKpi(x.data);
      } else {
        setKpi(null);
      }
    });
  }, []);

  useEffect(() => {
    if (kpi && kpi.boardType !== SIC_BOARD_TYPE.sic) {
      getData();
    }
  }, [kpi]);

  const getData = async () => {
    let resSectors = await getSectors(id);
    if (resSectors && resSectors.data?.length) {
      let resSectorMeasurables = await search({ isGetAll: true });
      let mappedData = resSectors.data
        .map(x => {
          let sectorMeasurables = resSectorMeasurables.items.filter(
            m => m.sectorId == x.id
          );
          return {
            ...x,
            measurables: sectorMeasurables
          };
        })
        .sort((a, b) => parseInt(a.value2) - parseInt(b.value2));
      setSectors(mappedData);
    }
  };

  var weekOfYear = require('dayjs/plugin/weekOfYear');
  dayjs.extend(weekOfYear);
  var currentWeek = dayjs().week();

  useEffect(() => {}, []);

  const handleEditSectorModal = sector => {
    setSectorModalShow(true);
    setSectorItem(sector);
  };

  const handleSubmitModal = () => {
    handleCloseModal();
    getData();
  };

  const handleCloseModal = () => {
    setSectorModalShow(false);
    setSectorItem({});
  };
  if (kpi?.boardType === SIC_BOARD_TYPE.sic) {
    return <Navigate to={buildSicBoardPath(kpi.id)} replace />;
  }

  return kpi === null ? (
    <Error404 />
  ) : (
    <>
      <PageHeader
        title={kpi?.name}
        col="col-lg-12"
        description={`Week no.${currentWeek} (calendar year) | ${kpi?.description}`}
        desComponent={
          <Col sm="auto" className="ms-auto d-flex justify-content-end">
            <Button
              style={{ height: '100%' }}
              variant="outline-primary"
              onClick={() => {
                setSectorModalShow(true);
              }}
            >
              Create Sector
            </Button>
          </Col>
        }
        className="mb-3 col-lg-12"
      ></PageHeader>

      {sectors.map((x, index) => {
        return (
          <Fragment key={index}>
            <br />
            <SectorCard
              key={index}
              sector={x}
              title={x.name}
              sectorId={x.id}
              setEditItem={handleEditSectorModal}
              setIsLoading={setIsLoading}
              sheduleTypeText={x.scheduleTypeText}
              sheduleTypeId={x.scheduleType}
              isShowTodayParam={x.isShowToday}
            />
          </Fragment>
        );
      })}
      <FullPageSpinner show={isLoading} quantity={3} variant="success" />
      <SectorModal
        isShow={isSectorModalShow}
        handleClose={handleCloseModal}
        data={sectorItem}
        handleSubmit={handleSubmitModal}
        kpiId={kpi?.id}
      />
    </>
  );
}
